import { NgModule } from '@angular/core';
import { IconButtonModule } from '../../../shared/directives/icon-button/icon-button.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { PdfHeaderComponent } from './pdf-header.component';
import { PdfSpacerModule } from '../pdf-spacer/pdf-spacer.module';


@NgModule({
  declarations: [
    PdfHeaderComponent
  ],
  exports: [
    PdfHeaderComponent
  ],
  imports: [
    IconButtonModule,
    CommonModule,
    TranslateModule,
    DragDropModule,
    PdfSpacerModule
  ],
  providers: []
})
export class PdfHeaderModule { }
